import FetchService from "./Shared/FetchService";
const baseURL = "/aviso/resourceGuide";
export default class ResourceService {
    static search(query) {
        return FetchService.getSingleResponse("/aviso/advisor/searchResources", {
            searchTerm: query,
        });
    }
    static shareResource(resourceId, affiliationId, comment = "") {
        return FetchService.postSingleResponse(baseURL +
            `/share?resourceId=${resourceId}&affiliationId=${affiliationId}`, { comment });
    }
    static canIShareResources() {
        return FetchService.getSingleResponse(baseURL + "/canIShareResources");
    }
    static isResourceGuideActive() {
        return FetchService.getSingleResponse(baseURL + "/isResourceGuideActive");
    }
}
